// extracted by mini-css-extract-plugin
module.exports = {"invitations":"MyInvitationsTabs_invitations__2Xb-Y","menu":"MyInvitationsTabs_menu__3uY4Z","focus":"MyInvitationsTabs_focus__2iWLz","wrapper":"MyInvitationsTabs_wrapper__Juvn0"};